import axios from 'axios'

var config = {
  headers: {
    'Content-type': 'application/json-patch+json',
  },
}
var configFile = {
  headers: {
    'Content-Type': 'multipart/form-data',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': '*',
    'cache-control': 'no-cache',
  },
}
export default ({
  scrollToTop (x, y) {
    window.scrollTo(x, y)
  },
  forceRerender1 (refPage) {
    refPage.renderComponent1 = false
    refPage.$nextTick(() => {
      refPage.renderComponent1 = true
    })
  },
  forceRerender2 (refPage) {
    refPage.renderComponent2 = false
    refPage.$nextTick(() => {
      refPage.renderComponent2 = true
    })
  },
  forceRerender3 (refPage) {
    refPage.renderComponent3 = false
    refPage.$nextTick(() => {
      refPage.renderComponent3 = true
    })
  },
  forceRerender4 (refPage) {
    refPage.renderComponent4 = false
    refPage.$nextTick(() => {
      refPage.renderComponent4 = true
    })
  },
  sendDataLog: function (store, datainf) {
    var InfData = {
      idUser: 1,
      date: new Date(),
      movementType: 'API/LoginPEM',
      method: 'POST',
      ip: datainf.ipaddr,
      request: datainf.upn,
      response: JSON.stringify(datainf),
    }
    console.log(InfData)

    /*
    axios.post(store.state.ApiIbero.WSAudit + 'Logs/', InfData, config).catch(e => function (e) {
      console.log(e)
    })
    */
  },
  // envia dataLogs de ingreso a intranet
  sendDataLogIntranet: function (store, modelLogs) {
    axios.post(store.state.ApiIbero.WSUtilitary + 'Avaya/NewLogsData', modelLogs).catch(e => function (e) {
      console.log(e)
    })
  },
  getDocTypeList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'DocumentTypes/GetAllDocumentType', config).then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.DocTypesList.push({ id: Response.data[i].idDocumentType, value: Response.data[i].nameDocumentType })
          store.state.DocTypesListICFES.push({ id: Response.data[i].idDocumentType, value: Response.data[i].nameDocumentType })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getMenuList: function (store, idPerson) {
    axios.get(store.state.ApiIbero.WSParametric + 'Menu/GetListShortcuts' + '/' + idPerson).then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.IberoPresen = Response.data
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getStateList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'State/GetListState').then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.StateList.push({ id: Response.data[i].codeState, value: Response.data[i].nameState })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getOperatorList: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.ADMIntranet + 'Operator/GetAllOperator/')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getCitiesListByState: function (endpoint, store, idref) {
    debugger
    axios.get(endpoint + 'City/ListByState/' + idref).then(
      Response => {
        store.length = 0
        for (var i = 0; i < Response.data.length; i++) {
          store.push({ id: Response.data[i].codeCity, value: Response.data[i].nameCity })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  GetEthnicityReference: function (endpoint, store, idref) {
    debugger
    axios.get(endpoint + 'Ethnicity/GetEthnicityReference/' + idref, config).then(
      Response => {
        store.length = 0
        for (var i = 0; i < Response.data.length; i++) {
          store.push({ id: Response.data[i].idEthnicity, value: Response.data[i].namEthnicity })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },

  // --------------
  /* Liquidación de Comisiones */
  // --------------

  GetOperatorList: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'LiquidacionComisiones/GetOperatorList')
      return this.availabilityMessage
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetEmptyOpList: async function (store, operator) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'LiquidacionComisiones/GetEmptyOpList/' + operator)
      return this.availabilityMessage
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetNullList: async function (store, operator) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'LiquidacionComisiones/GetNullList/' + operator)
      return this.availabilityMessage
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  PostOperatorFirstPart: async function (store, jsonData) {
    try {
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSUtilitary + 'LiquidacionComisiones/PostOperatorPart/', jsonData)
      return this.availabilityMessage
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  PostAnulados: async function (store, jsonData) {
    try {
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSUtilitary + 'LiquidacionComisiones/PostAnulado/', jsonData)
      return this.availabilityMessage
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },
  GetAnuladosvsConsolidado: async function (store, operator) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'LiquidacionComisiones/GetAnuladosvsConsolidado/' + operator)
      return this.availabilityMessage
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },
  PostAnuladosvsConsolidado: async function (store, jsonData) {
    try {
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSUtilitary + 'LiquidacionComisiones/PostAnuladovsConsolidado/', jsonData)
      return this.availabilityMessage
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },
  GetAnuladosvsConsolidadoP2: async function (store, operator) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'LiquidacionComisiones/GetAnuladosvsConsolidadop2/' + operator)
      return this.availabilityMessage
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },
  PostAnuladosvsConsolidadoP2: async function (store, jsonData) {
    try {
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSUtilitary + 'LiquidacionComisiones/PostAnuladovsConsolidadop2/', jsonData)
      return this.availabilityMessage
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetFinalReportPreComision: async function (store, operator) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'LiquidacionComisiones/GetFinalReportPreComision/' + operator)
      return this.availabilityMessage
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetFinalReportPreComisionPD: async function (store, operator) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'LiquidacionComisiones/GetFinalReportPreComisionPD/' + operator)
      return this.availabilityMessage
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },
  // --------------
  /* Academic Calendar Administrador */
  // --------------

  GetCalendarPermanencia: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'AcademicCalendar/GetCalendarPermanencia')
      return this.availabilityMessage // Devuelve la respuesta de axios.get
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetProgramsForCalendar: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'AcademicCalendar/GetPrograms')
      return this.availabilityMessage // Devuelve la respuesta de axios.get
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  AddProgramsForCalendar: async function (store, formDataCreate) {
    try {
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSParametric + 'AcademicCalendar/AddPrograms', formDataCreate)
      return this.availabilityMessage // Devuelve la respuesta de axios.post
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetCalendarForId: async function (store, dataId) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'AcademicCalendar/GetCalendarForId/' + dataId)
      return this.availabilityMessage // Devuelve la respuesta de axios.get
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetProgramForId: async function (store, dataId) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'AcademicCalendar/GetProgramForId/' + dataId)
      return this.availabilityMessage // Devuelve la respuesta de axios.get
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  EditProgramsForCalendar: async function (store, formDataEdit) {
    try {
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSParametric + 'AcademicCalendar/EditPrograms', formDataEdit)
      return this.availabilityMessage // Devuelve la respuesta de axios.post
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  DeleteProgramsForCalendar: async function (store, formDataDelete) {
    try {
      this.availabilityMessage = await axios.delete(store.state.ApiIbero.WSParametric + 'AcademicCalendar/DeleteProgramForId/' + formDataDelete)
      return this.availabilityMessage // Devuelve la respuesta de axios.post
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  // --------------
  /* Portal Empleado */
  // --------------
  GetUserPortalEmpleadoIceberg: async function (store, user) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'PortalEmpleado/GetUserIceberg/' + user)
      return this.availabilityMessage
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetUserUpdatePortalEmpleadoIceberg: async function (store, user) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'PortalEmpleado/GetResultUpdatePassword/' + user)
      return this.availabilityMessage
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  // --------------
  /* Ordenes Administrador */
  // --------------

  GetConceptoNotaIceberg: async function (store, conceptoNota) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Orders/ConceptoNotaGet/' + conceptoNota)
      return this.availabilityMessage // Devuelve la respuesta de axios.get
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetCreditoIceberg: async function (store, cliente, credito) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Orders/CreditoGet/' + cliente + '/' + credito)
      return this.availabilityMessage // Devuelve la respuesta de axios.get
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetLiquidacionOrdenDocumentsIceberg: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Orders/LiquidacionOrdenDocumentList')
      return this.availabilityMessage // Devuelve la respuesta de axios.get
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetLiquidacionOrderIceberg: async function (store, client, document, order) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Orders/LiquidacionOrdersList/' + client + '/' + document + '/' + order)
      return this.availabilityMessage // Devuelve la respuesta de axios.get
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetNotaDebitoIceberg: async function (store, cliente, notaDebito) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Orders/NotaDebitoGet/' + cliente + '/' + notaDebito)
      return this.availabilityMessage // Devuelve la respuesta de axios.get
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetNotaCreditoIceberg: async function (store, cliente, notaCredito) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Orders/NotaCreditoGet/' + cliente + '/' + notaCredito)
      return this.availabilityMessage // Devuelve la respuesta de axios.get
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetOrdenDocumentsIceberg: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Orders/OrdenDocumentList')
      return this.availabilityMessage // Devuelve la respuesta de axios.get
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetOrderIceberg: async function (store, period, document, order) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Orders/OrdersList/' + period + '/' + document + '/' + order)
      return this.availabilityMessage // Devuelve la respuesta de axios.get
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetReciboConsignacionIceberg: async function (store, period, client, recibConsig) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Orders/ReciboConsignacionGet/' + period + '/' + client + '/' + recibConsig)
      return this.availabilityMessage // Devuelve la respuesta de axios.get
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetSolicitudNotaIceberg: async function (store, period, client, numSol) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Orders/SolicitudNotaGet/' + period + '/' + client + '/' + numSol)
      return this.availabilityMessage // Devuelve la respuesta de axios.get
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  // --------------
  /* Eval Docente Administrador */
  // --------------

  GetEvalDocenteAdm: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'EvalDocenteAdministrador/GetGenericForm')
      return this.availabilityMessage // Devuelve la respuesta de axios.get
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetEvalDocenteAdmRoles: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'EvalDocenteAdministrador/GetRoles')
      return this.availabilityMessage // Devuelve la respuesta de axios.get
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetEvalDocenteAdmTypeForm: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'EvalDocenteAdministrador/GetTypeForm')
      return this.availabilityMessage // Devuelve la respuesta de axios.get
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetEvalDocenteAdmCreate: async function (store, formDataCreate) {
    try {
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSParametric + 'EvalDocenteAdministrador/AddGenericForm', formDataCreate)
      return this.availabilityMessage // Devuelve la respuesta de axios.post
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetEvalDocenteAdmEdit: async function (store, formDataEdit) {
    try {
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSParametric + 'EvalDocenteAdministrador/EditGenericForm', formDataEdit)
      return this.availabilityMessage // Devuelve la respuesta de axios.put
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetEvalDocenteAdmDelete: async function (store, formDataDelete) {
    try {
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSParametric + 'EvalDocenteAdministrador/DeleteGenericForm', formDataDelete)
      return this.availabilityMessage // Devuelve la respuesta de axios.delete
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  GetEvalDocenteAdmGetQuestions: async function (store, idTypeForm) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'EvalDocenteAdministrador/GetQuestions/' + idTypeForm)
      return this.availabilityMessage // Devuelve la respuesta de axios.delete
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },

  EvalDocenteAdmAddQuestion: async function (store, dataObject) {
    try {
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSParametric + 'EvalDocenteAdministrador/AddQuestionsForm', dataObject)
      return this.availabilityMessage // Devuelve la respuesta de axios.post
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null // Devuelve un valor en caso de error
    }
  },

  GetEvalDocenteAdmGFQuestions: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'EvalDocenteAdministrador/GetGenericFormQuestions')
      return this.availabilityMessage // Devuelve la respuesta de axios.post
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null // Devuelve un valor en caso de error
    }
  },

  GetEvalDocenteAdmQuestionsTwo: async function (store, idTypeForm) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'EvalDocenteAdministrador/GetQuestionsTwo/' + idTypeForm)
      return this.availabilityMessage // Devuelve la respuesta de axios.post
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null // Devuelve un valor en caso de error
    }
  },

  // --------------
  /* Eval Percent */
  // --------------

  GetEvalPercent: async function (store, module) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'EvalDocente/GetEvalPercent')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  AddEvalPercent: async function (store, InfData) {
    try {
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSParametric + 'EvalDocente/AddEvalPercent', InfData)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },

  EditEvalPercent: async function (store, InfData) {
    try {
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSParametric + 'EvalDocente/EditEvalPercent', InfData)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },

  // --------------
  /* Eval Roles */
  // --------------

  GetEvalRoles: async function (store, module) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'EvalDocente/GetEvalRoles')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  GetEvalRolesSelect: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'EvalDocente/GetSelect').then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.EvalRolList.push({ id: Response.data[i].id, value: Response.data[i].rol })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },

  AddEvalRoles: async function (store, InfData) {
    try {
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSParametric + 'EvalDocente/AddEvalRoles', InfData)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },

  EditEvalRoles: async function (store, InfData) {
    try {
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSParametric + 'EvalDocente/EditEvalRoles', InfData)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },

  // --------------
  /* Fin Eval Roles */
  // --------------

  // -------------------
  /* Inicio Eval Type */
  // -------------------

  GetEvalType: async function (store, module) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalDocente/GetEvalType')
    } catch (error) {
      this.availabilityMessage = false
    }
    return this.availabilityMessage
  },

  getPersonList: async function (store, refData, typePersons) {
    try {
      if (refData.numIdentify && refData.IdBannerNum) {
        this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Person/GetAll/' + refData.IdBannerNum + '/' + refData.numIdentify + '/' + typePersons)
      } else if (refData.numIdentify && !refData.IdBannerNum) {
        this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Person/GetAll/0/' + refData.numIdentify + '/' + typePersons)
      } else if (!refData.numIdentify && refData.IdBannerNum) {
        this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Person/GetAll/' + refData.IdBannerNum + '/0/' + typePersons)
      } else {
        this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Person/GetAll/0/0/' + typePersons + '/')
      }
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getConfigModule: async function (store, module) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Configuration/GetConfiguration/' + module)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getHistoryOM: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'OrdersEnrollment/GetHistory/')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getPeriodLoad: async function (store) {
    debugger
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'OrdersEnrollment/GetOrderLoad/')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getPeriodList: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Period/GetAllPeriod')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  GetCertificateType: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'CertificateType/GetCertificateType/')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  addCertificateType: async function (store, InfData) {
    try {
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSParametric + 'CertificateType/AddCertificateType/', InfData)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },

  EditCertificateType: async function (store, InfData) {
    try {
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSParametric + 'CertificateType/EditCertificateType', InfData)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },

  GetGoals: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Goals/GoalsGeneral/')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  GetGoalsById: async function (store, id) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Goals/GoalsById/' + id)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  UpdateGoals: async function (store, InfData) {
    try {
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSParametric + 'Goals/UpdateGoals', InfData)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },

  InsertGoals: async function (store, InfData) {
    try {
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSParametric + 'Goals/Goals', InfData)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },

  getUserLoginAuth: async function (store, mail, token) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Person/ListPersonByEmailv2/' + mail + '/' + process.env.VUE_APP_TOKEN + '/' + token)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getToken: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Token/Generate_Token/' + process.env.VUE_APP_TOKEN)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage.data.token
  },
  getMenuData: async function (store, ref, idMenu) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Menu/GetListMenu/' + ref + '/' + idMenu)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getCasesData: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Cases/AllCases/')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getMailsData: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Mail/GetMailAll/')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  sendMailbyId: async function (store, idMail) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Mail/SendMails/' + idMail)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  sendTablePonderadobyId: async function (store, id) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalDocenteAdm/sendTablePonderadobyId/' + id)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getAreaByPerson: async function (store, idPerson, refModule) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Area/GetAreaByRolePerson/' + idPerson + '/' + refModule)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getAreaFormByPerson: async function (store, idarea, codrol, idPerson, idEdit) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Feedback/GetFormFeedback/' + idarea + '/' + codrol + '/' + idPerson + '/' + idEdit)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getAreaListByPerson: async function (store, idarea, codrol, idPerson) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Feedback/GetListFeedback/' + idarea + '/' + codrol + '/' + idPerson)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getCasedata: async function (store, idRef, idCase) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Cases/GetCaseById/' + idRef + '/' + idCase)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getCasedataFaculty: async function (store, idref, iduser) {
    try {
      debugger
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Cases/GetCaseByFacultyProgram/' + idref + '/' + iduser)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getOrdenesdata: async function (store, idPerido, idDocument, iYear) {
    try {
      if (idDocument === '') idDocument = '0'
      if (idPerido === '') idPerido = '1'
      if (iYear === '') iYear = '0'

      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EnrollmentOrder/ReportOrder/' + idPerido + '/' + idDocument + '/1/1/' + iYear)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }

    return this.availabilityMessage
  },
  getOrdenesGeneradasdata: async function (store, idPerido, idDocument, iYear) {
    try {
      if (idDocument === '') idDocument = '0'
      if (idPerido === '') idPerido = '1'
      if (iYear === '') iYear = '0'

      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EnrollmentOrder/ReportOrdenesGeneradas/' + idPerido + '/' + idDocument + '/1/1/' + iYear)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }

    return this.availabilityMessage
  },
  GetCaseByUpdate: async function (store, idref, iduser) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Cases/GetCaseByUpdate/' + idref + '/' + iduser)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getRolData: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Role/getAllRol/')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getRolByMenuData: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Role/GetRolByMenu/')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getAreasUser: async function (store, IdPerson) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Area/GetAreaByUserList/' + IdPerson)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  updateAreaByPerson: async function (store, listData, idRef) {
    try {
      var InfData = {
        idReference: idRef,
        listAreas: listData,
      }
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSParametric + 'Area/UpdateUserArea/', InfData, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  getFaculties: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'Faculty/GetAllFaculty/').then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.FacultyList.push({ id: Response.data[i].idFaculty, value: Response.data[i].namFaculty })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },

  getCalendarioA: async function (store, refData) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'AcademicC/AllPeriod')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  getPeriod: async function (store, refData) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Period/GetAllPeriodActiveInactive/')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    debugger
    return this.availabilityMessage
  },

  getProgramPlan: async function (store, refData) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Program/GetAllPlanProgramaActiveInactive/')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    debugger
    return this.availabilityMessage
  },

  getPeriodProgList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'Period/GetAllPeriodActiveInactive/').then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.PermanenceList.push({ id: Response.data[i].idPeriod, value: Response.data[i].desPeriod + '-' + Response.data[i].typeIncome })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },

  getProgramsByPeriod: async function (store, refData) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'AcademicC/ProgramByPeriod/' + refData + '/')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  getPrograms: async function (store, refData) {
    try {
      if (refData.idFaculty) {
        this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Program/ListByFaculty/' + refData.idFaculty + '/')
      } else {
        this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Program/GetAllProgram/')
      }
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  getPrograms2: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'Program/GetAllProgram2/').then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.ProgramList.push({ id: Response.data[i].Id_Program, value: Response.data[i].Nam_Program })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getPlan: function (store) {
    debugger
    axios.get(store.state.ApiIbero.WSParametric + 'Program/GetAllPlan/').then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.PlanList.push({ id: Response.data[i].Id_Plan, value: Response.data[i].Nam_Plan })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getPlanIdProgram: function (store, ipPrograma) {
    debugger
    axios.get(store.state.ApiIbero.WSParametric + 'Program/GetPlanIdProgram/' + ipPrograma).then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.PlanList.push({ id: Response.data[i].Id_Plan, value: Response.data[i].Nam_Plan })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  OperatorProgramList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'OperatorProgram/GetAllPeriod/1/1/').then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.PermanenceList.push({ id: Response.data[i].Id_Operator, value: Response.data[i].Nam_Operator })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },

  getPrograms3: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'AcademicC/AllPeriod/').then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.ProgramList2.push({ id: Response.data[i].id, value: Response.data[i].periodO_BANNER })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },

  getDegrees: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'Degree/GetAllDegree/').then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.DegreeList.push({ id: Response.data[i].idDegree, value: Response.data[i].namDegree })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  addProgram: async function (store, InfData) {
    try {
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSParametric + 'Program/', InfData)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  addOperatorProgram: async function (store, textvalue) {
    try {
      debugger
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSParametric + 'OperatorProgram/AddOperatorProgram/', textvalue)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
      debugger
    };
    return this.availabilityMessage
  },
  addModalitiesProgram: async function (store, textvalue) {
    try {
      debugger
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSParametric + 'ProgramsPeriodModalites/AddOPeriodProgram/', textvalue)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
      debugger
    };
    return this.availabilityMessage
  },
  addPeriod: async function (store, InfData) {
    try {
      debugger
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSParametric + 'Period', InfData)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  addProgramaPlan: async function (store, InfData) {
    try {
      debugger
      var Data = {
        idProgram: InfData.idProgram,
        idPlan: InfData.idPlan,
        staActive: InfData.staActive,
      }
      debugger
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSParametric + 'Program/CreateProgramPlan/', Data, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  updateProgramaPlan: async function (store, InfData) {
    try {
      debugger
      var Data = {
        idProgram: InfData.idProgram,
        idPlan: InfData.idPlan,
        staActive: InfData.staActive,
      }
      debugger
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSParametric + 'Program/UpdateProgramPlan/', Data, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  addPCalendarioA: async function (store, InfData) {
    try {
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSParametric + 'AcademicC/InsertCalendat/', InfData)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },

  updateProgram: async function (store, InfData) {
    try {
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSParametric + 'Program/UpdateProgram/', InfData)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },

  updatePeriod: async function (store, InfData) {
    try {
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSParametric + 'Period/UpdatePeriod/', InfData)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },

  updateCalendarioA: async function (store, InfData) {
    try {
      debugger
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSParametric + 'AcademicC/EditCalendar/', InfData)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },

  updateCaseByPerson: async function (store, InfData) {
    try {
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'Cases/UpdateCaseUser/', InfData)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },

  getStatusOM: async function (store, IdRef) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'OrdersEnrollment/GetAllEnrollmentOrder/' + IdRef + '/')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  /// ///////////////////

  getPermanence: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'Permanence/GetPermanence/').then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.PermanenceList.push({ id: Response.data[i].id, value: Response.data[i].period })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getPermanenceById: async function (store, refData) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Permanence/GetPermanenceById/2/' + '0' + '/' + refData.value + '/')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getPermanenceByoperator: async function (store, refData) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Permanence/GetCentroById/3/' + refData + '/')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  getPermanenceByIdPeriod: async function (store, refData) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Permanence/GetAllCalendarP/4/' + refData + '/')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  getAllPermanenceProgram: async function (store, refData) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Permanence/GetPermanenceByIdPeriod/2/')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }

    return this.availabilityMessage
  },

  /// ///////////////
  executeLoadView: async function (store, executeETL) {
    try {
      this.executeMSN = await axios.put(store.state.ApiIbero.WSUtilitary + 'OrdersEnrollment/ExecuteLoadView', config)
    } catch (error) {
      this.executeMSN = false
      console.log(error)
    }
    return this.executeMSN
  },
  sendPeriodsOM: async function (store, listPeriods) {
    try {
      this.updateMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'OrdersEnrollment/SendPeriods', { listPeriods }, config)
    } catch (error) {
      this.updateMessage = false
      console.log(error)
    }
    return this.updateMessage
  },
  sendStatusOM: async function (store, idref, idUser, listStatus) {
    try {
      var StatusRef = []
      for (var i = 0; i < listStatus.length; i++) {
        StatusRef.push({
          Id_ViewTuitionPeriod: listStatus[i].idViewTuitionPeriod,
          Sta_NextPeriod: listStatus[i].staNextPeriod,
          Id_UpdatedBy: idUser,
          Is_Modified: true,
        })
      }

      var DataStatus = {
        idLoadView: idref,
        statusOrders: StatusRef,
      }

      this.updateMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'OrdersEnrollment/UpdateStatus/', DataStatus, config)
    } catch (error) {
      this.updateMessage = false
      console.log(error)
    }
    return this.updateMessage
  },
  sendStatusOMFinal: async function (store) {
    try {
      this.updateMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'OrdersEnrollment/UpdateStatusBanner/', config)
    } catch (error) {
      this.updateMessage = false
      console.log(error)
    }
    return this.updateMessage
  },
  addVotoUser: async function (store, iduser, listVoto) {
    try {
      var InfData = {
        idRange: parseInt(listVoto.refVoto),
        idPerson: parseInt(iduser),
        idVotoStudent: (listVoto.student !== '') ? parseInt(listVoto.student) : 0,
        idVotoTeacher: (listVoto.teacher !== '') ? parseInt(listVoto.teacher) : 0,
      }
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'Voting/AddVotingUser/', InfData, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getListCaracterizacion: async function (store, ref) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Characterization/AllCharacterization/' + ref)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getDatCaractbyIdPerson: async function (store, idcarat, idPerson) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Characterization/GetCharacByPerson/' + idPerson + '/' + idcarat)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getDatCaractbyId: async function (store, idcarat, ref) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Characterization/GetCharacterizationById/' + ref + '/' + idcarat)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  addDatCaractbyId: async function (store, idPerson, idcarat, formSend) {
    try {
      var InfData = {
        idPerson: idPerson,
        idCharacterization: idcarat,
        dataForm: formSend,
      }
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'Characterization/AddCharacterizationForm/', InfData, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  addDataFeedBack: async function (store, idPerson, refFrom, refMail, refPDF, formSend) {
    try {
      var InfData = {
        reference: refFrom,
        idPerson: idPerson,
        codMailing: refMail,
        codPdf: refPDF,
        dataFeedBack: formSend,
      }
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'Feedback/ProcessFeedbackByPerson/', InfData, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  updateConfigById: async function (store, dataConf) {
    try {
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSParametric + 'Configuration/UpdateConfiguration/', { listParams: dataConf }, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  listVotingUser: async function (store, iduser) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Voting/GetVotingUser/' + iduser)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  listVotingRange: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Voting/GetVotingRange')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getDatShortCoursebyId: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'ShortCourse/GetShortCourseReport/')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  getDatSummaryRegistration: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Reports/GetSummaryRegistrationForm/')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  processCase: async function (store, InfDataAdd, InfDataUpd) {
    try {
      if (InfDataAdd.length >= 1) {
        var listdataAdd = { caseRef: 3, listCase: InfDataAdd }
        this.availabilityMessageAdd = await axios.put(store.state.ApiIbero.WSUtilitary + 'Cases/ProcessCase/', listdataAdd, config)
        this.availabilityMessage[0] = this.availabilityMessageAdd
      }
      if (InfDataUpd.length >= 1) {
        var listdataUpd = { caseRef: 4, listCase: InfDataUpd }
        this.availabilityMessageUpd = await axios.put(store.state.ApiIbero.WSUtilitary + 'Cases/ProcessCase/', listdataUpd, config)
        this.availabilityMessage[1] = this.availabilityMessageUpd
      }
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  updateMenu: async function (store, InfData, refUpt) {
    try {
      var listOrderMenu = { menuRef: refUpt, listMenu: InfData }
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSParametric + 'Menu/UpdateMenu/', listOrderMenu, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  updateRoleByMenu: async function (store, RolesMenus) {
    try {
      var InfData = {
        listRoles: RolesMenus,
      }
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSParametric + 'Role/UpdateRolByMenu/', InfData, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  updateRoleByPerson: async function (store, listData, idRef) {
    try {
      var InfData = {
        idReference: idRef,
        listRoles: listData,
      }
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'Person/UpdatePersonRol/', InfData, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  updateStatusPerson: async function (store, listData, idRef) {
    try {
      var InfData = {
        idReference: idRef,
        idBanner: listData.IdBanner,
        idPerson: listData.IdPerson,
        mailPerson: listData.IdUsrName,
        numDocument: listData.IdDocument,
        idStatus: listData.IdStatus,
      }
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'Person/UpdatePersonStatus/', InfData, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  addCaseByPerson: async function (store, listData) {
    try {
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'Cases/AddCaseUser/', listData, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  sendFormUpdate: async function (store, datainf) {
    try {
      var InfData = {
        idPerson: datainf.IdPerson,
        idBanner: datainf.IdBanner,
        idDocumentType: datainf.IdDocType,
        nameDocumentType: '' + datainf.IdDocType,
        numDocument: datainf.IdDocument,
        namPerson: datainf.IdNombre,
        lastNamePerson: datainf.IdApellidos,
        resAddress: datainf.IdAddress,
        codResidenceDepartment: datainf.IdState,
        nameResidenceDepartment: this.dataObjFind(store.state.StateList, datainf.IdState),
        codResidenceCity: datainf.IdCity,
        nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
        idUpdatedBy: datainf.idUpdatedBy,
        nameResidenceNeighborhood: datainf.IdAddress,
        termsConditions: datainf.IdTermiCondi,
        infReceive: datainf.IdNewsLetter,
        idContactTypePhone: 1,
        desContactInformationPhone: datainf.IdHomePhone,
        idContactTypePhoneEmergency: 4,
        desContactInformationPhoneEmergency: datainf.IdCelPhone,
        idContactTypeMobile: 2,
        desContactInformationMobile: datainf.IdCelPhone,
        idContactTypeEmail: 3,
        desContactInformationEmail: datainf.IdMail,
        idPersonOperator: 0,
        idOperator: 0,
        observation: datainf.IdObservaciones,
        staActive: datainf.IdStatus,
      }
      debugger
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'Person/UpdatePerson/', InfData, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  sendFormUpdateIntranet: async function (store, datainf) {
    try {
      debugger
      var InfData = {
        idPerson: datainf.IdPerson,
        idBanner: datainf.IdBanner,
        idDocumentType: datainf.IdDocType,
        nameDocumentType: '' + datainf.IdDocType,
        numDocument: datainf.IdDocument,
        bornDate: datainf.IdBornMon + '/' + datainf.IdBornDay + '/' + datainf.IdBornYear,
        namPerson: datainf.IdNombre,
        lastNamePerson: datainf.IdApellidos,
        resAddress: datainf.IdAddress,
        codResidenceDepartment: datainf.IdState,
        nameResidenceDepartment: this.dataObjFind(store.state.StateList, datainf.IdState),
        codResidenceCity: datainf.IdCity,
        nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
        idUpdatedBy: datainf.idUpdatedBy,
        nameResidenceNeighborhood: datainf.IdAddress,
        termsConditions: datainf.IdTermiCondi,
        infReceive: datainf.IdNewsLetter,
        idContactTypePhone: 1,
        desContactInformationPhone: datainf.IdHomePhone,
        idContactTypePhoneEmergency: 4,
        desContactInformationPhoneEmergency: datainf.IdCelPhone,
        idContactTypeMobile: 2,
        desContactInformationMobile: datainf.IdCelPhone,
        idContactTypeEmail: 3,
        desContactInformationEmail: datainf.IdMail,
        idPersonOperator: 0,
        idOperator: 0,
        observation: datainf.IdObservaciones,
        staActive: datainf.IdStatus,
      }
      debugger
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'Person/UpdatePersonIntranet/', InfData, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  sendFormUpdateOperator: async function (store, datainf) {
    try {
      for (var i = 0; i < datainf.length; i++) {
        var InfDataOperator = {
          idBanner: datainf[i].IdBanner,
          idProgram: 0,
          idPersonOperator: datainf[i].actPeriod.idPersonOperator,
          idPerson: datainf[i].actPeriod.idPerson,
          idOperator: datainf[i].idOperator,
          idPeriod: datainf[i].actPeriod.idPeriod,
          isLiquid: datainf[i].actPeriod.isLiquid,
          idOperatorPeriod: datainf[i].actPeriod.idOperatorPeriod,
        }
        this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'Person/UpdatePersonOperators/', InfDataOperator, config)
      }
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  dataObjDate: function (InfDaT) {
    var d = new Date(InfDaT)
    var month = '' + (d.getMonth() + 1)
    var day = '' + d.getDate()
    var year = d.getFullYear()

    if (month.length < 2) { month = '0' + month }
    if (day.length < 2) { day = '0' + day }

    return [day, month, year].join('/')
  },
  dataTimeObjDate: function (InfDaT) {
    var d = new Date(InfDaT)
    var month = '' + (d.getMonth() + 1)
    var day = '' + d.getDate()
    var year = d.getFullYear()
    var hora = d.getHours()
    var minuto = d.getMinutes()

    if (month.length < 2) { month = '0' + month }
    if (day.length < 2) { day = '0' + day }
    if (hora < 10) { hora = '0' + hora }
    if (minuto < 10) { minuto = '0' + minuto }

    return day + '/' + month + '/' + year + ' - ' + hora + ':' + minuto
  },
  dataObjFind: function (infoDaT, FinDaT) {
    if (infoDaT !== '' || FinDaT !== '') {
      var valuefin = infoDaT.find(element => element.id === FinDaT)
      if (valuefin !== undefined) {
        return valuefin.value
      } else {
        return ''
      }
    }
    return FinDaT
  },
  uniqueBy: function (arr, prop) {
    return arr.reduce((a, d) => {
      if (!a.includes(d[prop])) { a.push(d[prop]) }
      return a
    }, [])
  },
  // #region BulkInscription
  processBulkInscription: async function (store, InfData) {
    var sresp
    try {
      sresp = await axios.put(store.state.ApiIbero.WSUtilitary + 'Inscription/AddBulkInscription?Id_File=' + InfData.Id_File)
    } catch (error) {
      sresp = 'error'
      console.log(error)
    }
    return sresp
  },
  // #endregion

  // #region Formuario de inscripcion

  // #endregion

  // #Region Xertify
  processBulkCertificate: async function (store, InfData) {
    var sresp
    try {
      sresp = await axios.put(store.state.ApiIbero.WSUtilitary + 'Xertify/AddBulkCertification?Id_File=' + InfData.Id_File)
    } catch (error) {
      sresp = 'error'
      console.log(error)
    }
    return sresp
  },

  sendBulkXertify: async function (store, Id_File) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Xertify/GenerateXertifyMassive/' + Id_File)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    debugger
    return this.availabilityMessage
  },

  getBulkXertifyList: async function (store, Id_File) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Xertify/ListBulkCertificate/' + Id_File)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  // #endRegion Xertify

  // #region utilities
  sendUpdloadFile: async function (store, file, module, iduser) {
    try {
      var availabilityMessageFile = new Array()
      for (var i = 0; i < file.length; i++) {
        let formData = new FormData()
        formData.append('file', file[i].filedata)
        let availabilityMSF = await axios.post(store.state.ApiIbero.WSUtilitary + 'Utilities/UploadFile?Nam_Module=' + module + '&Id_FilePerson=' + iduser, formData, configFile)
        availabilityMessageFile.push({ idDocument: file[i].idFileModule, idUserSign: file[i].idDetailUser, wsDocument: availabilityMSF })
      }
      this.availabilityMessage = availabilityMessageFile
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  // #endregion

  // #region App Operadores

  getItemsMenu: async function (store, idPerson, Menu) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Menu/GetItemsMenu' + '/' + idPerson + '/' + Menu)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  getPersonByOperatorList: async function (store, refData) {
    try {
      refData.IdBanner = refData.IdBannerNum === '' ? '0' : refData.IdBannerNum
      refData.NumDocument = refData.NumIdentify === '' ? '0' : refData.NumIdentify
      refData.CodeOperatorBanner = refData.CodeOperator
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Operator/GetAllOperatorStudents/' + refData.IdBanner + '/' + refData.NumDocument + '/' + refData.CodeOperatorBanner)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getOperatorsByUser: async function (store, idPerson) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Operator/GetOperatorByUser/' + idPerson)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getListAdministrative: async function (store, idPerson) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalAdministrative/GetAdministrative/' + idPerson)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getOperatorsReportsIcetexByUser: async function (store, idPerson) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Operator/GetOperatorReportsIcetexByUser/' + idPerson)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getprogramByOperator: async function (store, value) {
    debugger
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'OperatorProgram/GetAllPeriod/2/' + value)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  getModalitPeriodList: async function (store, textvalue) {
    debugger
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'ProgramsPeriodModalites/GetAllPeriodprogram/' + textvalue)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    debugger
    return this.availabilityMessage
  },

  showmodalistProgram: async function (store, textvalue) {
    debugger
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'ProgramsPeriodModalites/GetAllPeriodprogram/' + textvalue)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    debugger
    return this.availabilityMessage
  },

  getFinancialStateByOperator: async function (store, refData) {
    try {
      refData.IdBanner = refData.IdBannerNum === '' ? '0' : refData.IdBannerNum
      refData.NumDocument = refData.NumIdentify === '' ? '0' : refData.NumIdentify
      refData.CodeOperatorBanner = refData.CodeOperator
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Operator/GetAllOperatorStudentsFinancialState/' + refData.IdBanner + '/' + refData.NumDocument + '/' + refData.CodeOperatorBanner)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getStudenPeriodByOperator: async function (store, refData) {
    try {
      refData.IdBanner = refData.IdBannerNum === '' ? '0' : refData.IdBannerNum
      refData.NumDocument = refData.NumIdentify === '' ? '0' : refData.NumIdentify
      refData.CodeOperatorBanner = refData.CodeOperator
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Operator/GetAllOperatorStudentsPeriod/' + refData.IdBanner + '/' + refData.NumDocument + '/' + refData.CodeOperatorBanner)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getStudentsPortfolioStatus: async function (store, refData) {
    try {
      refData.IdBanner = refData.IdBannerNum === '' ? '0' : refData.IdBannerNum
      refData.NumDocument = refData.NumIdentify === '' ? '0' : refData.NumIdentify
      refData.CodeOperatorBanner = refData.CodeOperator
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Operator/GetAllOperatorStudentsPortfolioStatus/' + refData.IdBanner + '/' + refData.NumDocument + '/' + refData.CodeOperatorBanner)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getStudentsLastEntryToPlataform: async function (store, refData) {
    try {
      refData.IdBanner = refData.IdBannerNum === '' ? '0' : refData.IdBannerNum
      refData.NumDocument = refData.NumIdentify === '' ? '0' : refData.NumIdentify
      refData.CodeOperatorBanner = refData.CodeOperator
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Operator/GetLastEntryToPlataform/' + refData.IdBanner + '/' + refData.NumDocument + '/' + refData.CodeOperatorBanner)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getStudentsNotes: async function (store, refData) {
    try {
      refData.IdBanner = refData.IdBannerNum === '' ? '0' : refData.IdBannerNum
      refData.NumDocument = refData.NumIdentify === '' ? '0' : refData.NumIdentify
      refData.CodeOperatorBanner = refData.CodeOperator
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Operator/ListOperatorStudentsNotes/' + refData.IdBanner + '/' + refData.NumDocument + '/' + refData.CodeOperatorBanner)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getCommissions: async function (store, refData) {
    try {
      refData.CodeOperatorBanner = refData.CodeOperator
      debugger
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Operator/ListOperatorCommissions/' + refData.CodeOperatorBanner)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    debugger
    return this.availabilityMessage
  },
  // eslint-disable-next-line no-dupe-keys
  getOperatorList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'Operator/GetAllOperator/', config).then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.OperatorList.push({ id: Response.data[i].idOperator, value: Response.data[i].namOperator })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getOperatorByName: async function (store, opera) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Operator/GetOperatorByName/' + opera, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getDegreeList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'Degree/GetAllDegreeIbero/', config).then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.DegreeList.push({ id: Response.data[i].idDegree, value: Response.data[i].namDegree, codVal: Response.data[i].codDegree })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })

    axios.get(store.state.ApiIbero.WSParametric + 'Degree/GetAllDegreeHomologation/', config).then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.HomDegreeList.push({ id: Response.data[i].idDegree, value: Response.data[i].namDegree })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getBondsList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'Bond/GetAllBonds', config).then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.BondsList.push({ id: Response.data[i].Id_Bond, value: Response.data[i].Name_Bond })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getPQRSList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'PQRS/GetAllPQRSType', config).then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.PQRSList.push({ id: Response.data[i].Id_PQRSType, value: Response.data[i].Nam_PQRSType })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getProgramsList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'Program/GetProgramBanner', config).then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.ProgramsList.push({ id: Response.data[i].Hom_Banner, value: Response.data[i].Nam_Program })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getAllCertificateType: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'Certificate/GetTypeCertificate', config).then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.CertificatesList.push({ id: Response.data[i].Id_Case_Zoho, value: Response.data[i].Name })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },

  getModalitiesList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'Modality/GetAllModality', config).then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.ModalitiesList.push({ id: Response.data[i].homBanner, value: Response.data[i].namModality })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  findUserInscription: async function (store, datainf) {
    try {
      debugger
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Inscription/GetSignUpPersonByZoho/' + datainf.IdDocType + '/' + datainf.IdDocument)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  //= ===========================================================================================================
  // función para devolver los grados
  //= ===========================================================================================================
  getGrade: async function (store, refData) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Grades/GetAllGrades')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  //= ===========================================================================================================
  // función para devolver las inscripcion por grado
  //= ===========================================================================================================
  getInscriptionGradesList: async function (store, refData) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Grades/ListInscriptionByGrade/' + refData)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    debugger
    return this.availabilityMessage
  },

  //= ===========================================================================================================
  // función para devolver ultimo grado
  //= ===========================================================================================================
  getGradeActive: async function (store, refData) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Grades/GetGradeActive')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  //= ===========================================================================================================
  // función para consultar los estudiantes inscritos en el proceso de grados activo
  //= ===========================================================================================================
  GetActiveInscriptionStudents: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Grades/GetActiveInscriptionStudents')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  //= ===========================================================================================================
  // función para consultar un estudiante inscrito por id banner
  //= ===========================================================================================================
  GetActiveInscriptionStudentByIdBanner: async function (store, idBanner) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Grades/GetActiveInscriptionStudentByIdBanner/' + idBanner)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  //= ===========================================================================================================
  // función para consultar un estudiante inscrito por documento
  //= ===========================================================================================================
  GetActiveInscriptionStudentByDocument: async function (store, idTypeDocument, documentNumber) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Grades/GetActiveInscriptionStudentByDocument/' + idTypeDocument + '/' + documentNumber)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  //= ===========================================================================================================
  // función para validar acceso al modulo de grados por id banner
  //= ===========================================================================================================
  GetActiveInscriptionAccessByIdBanner: async function (store, idBanner) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Grades/GetActiveInscriptionAccessByIdBanner/' + idBanner)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  //= ===========================================================================================================
  // función para consultar los documentos de la inscripcion activa por id banner
  //= ===========================================================================================================
  GetActiveInscriptionFilesByIdBanner: async function (store, idBanner, filters = {}) {
    try {
      this.availabilityMessage = await axios.get(
        store.state.ApiIbero.WSUtilitary + 'Grades/GetActiveInscriptionFilesByIdBanner/' + idBanner,
        {
          params: {
            idPerson: filters.idPerson || '',
            idGrade: filters.idGrade || '',
          },
        }
      )
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  //= ===========================================================================================================
  // función para consultar las ordenes de pago del cliente en iceberg
  //= ===========================================================================================================
  GetPaymentOrdersByClient: async function (store, client) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'PaymentOrder/GetPaymentOrdersByClient/' + client)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  //= ===========================================================================================================
  // función para consultar los datos del estudiante por id usuario
  //= ===========================================================================================================
  getDataPersonGrade: async function (store, id_user) {
    try {
      await axios.get(store.state.ApiIbero.WSUtilitary + 'Grades/GetDataPersonGrade/' + id_user).then(
        Response => {
          this.availabilityMessage = Response
          if (store.state.ProgramList2.length === 0) {
            for (var i = 0; i < Response.data.program.length; i++) {
              store.state.ProgramList2.push({ id: Response.data.program[i].cod_Program, value: Response.data.program[i].program })
            }

            for (var i = 0; i < Response.data.program.length; i++) {
              store.state.ModalityList.push({ id: Response.data.program[i].cod_Program, value: Response.data.program[i].level })
            }

            for (var i = 0; i < Response.data.operator.length; i++) {
              store.state.OperatorGradeList.push({ id: Response.data.operator[i].cod_Operator, value: Response.data.operator[i].operator })
            }
          }
        })
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  //= ===========================================================================================================
  // función para agregar grados
  //= ===========================================================================================================
  AddGrade: async function (store, InfData, user) {
    try {
      var Data = {
        Period_Grade: InfData.Period_Grade,
        Date_Grade: InfData.Date_Grade,
        Information: InfData.Information,
        Percent_Approved: InfData.Percent_Approved,
        staActive: InfData.staActive,
        Creation_User: user,
        dat_StartInscription: InfData.dat_StartInscription,
        dat_EndInscription: InfData.dat_EndInscription,
        existCeremony: InfData.existCeremony,
      }
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSParametric + 'Grades/AddGrade/', Data, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  //= ===========================================================================================================
  // función para validar datos
  //= ===========================================================================================================
  ValidationsGrade: async function (store, InfData, Grade) {
    try {
      var Data = {
        id_banner: InfData.IdBanner,
        codProgram: InfData.IdInteProgram,
        program: this.dataObjFind(store.state.ProgramList2, InfData.IdInteProgram),
        PeriodGrade: Grade,
      }
      console.log(Data)
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSUtilitary + 'Grades/ValidateGradePerson/', Data, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  //= ===========================================================================================================
  // función para actualizar grados
  //= ===========================================================================================================
  UpdateGrade: async function (store, InfData, user) {
    try {
      var Data = {
        Id_Grade: InfData.Id_Grade,
        Period_Grade: InfData.Period_Grade,
        Date_Grade: InfData.Date_Grade,
        Information: InfData.Information,
        Percent_Approved: InfData.Percent_Approved,
        staActive: InfData.staActive,
        Creation_User: user,
        dat_StartInscription: InfData.dat_StartInscription,
        dat_EndInscription: InfData.dat_EndInscription,
        existCeremony: InfData.existCeremony,
      }
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSParametric + 'Grades/UpdateGrade/', Data, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  //= ===========================================================================================================
  // función para archivos grados
  //= ===========================================================================================================
  sendUpdloadFileChangeName: async function (store, file, module, nameFile, iduser) {
    try {
      var availabilityMessageFile = new Array()
      for (var i = 0; i < file.length; i++) {
        let formData = new FormData()
        formData.append('file', file[i].filedata)
        let availabilityMSF = await axios.post(store.state.ApiIbero.WSUtilitary + 'Utilities/UploadFileChangeName?Nam_Module=' + module + '&Id_FilePerson=' + iduser + '&name=' + nameFile, formData, configFile)
        availabilityMessageFile.push({ idDocument: file[i].idFileModule, idUserSign: file[i].idDetailUser, wsDocument: availabilityMSF })
      }
      this.availabilityMessage = availabilityMessageFile
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },

  //= ===========================================================================================================
  // función para insertar informacion grados
  //= ===========================================================================================================
  sendFormInscriptionGrades: async function (store, dataInf) {
    debugger
    try {
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSUtilitary + 'Grades/AddInscriptionGrades/', dataInf, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  //= ===========================================================================================================
  // función para devolver las materias que esta viendo el estudiante en el ultimo periodo recuperado en banner
  //= ===========================================================================================================
  getSignature: async function (store, idbanner) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalDocente/GetBannerData/' + idbanner)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  //= ===========================================================================================================
  // función para obtener el formulario respectivo dependiendo del rol, ciclo y periodo
  //= ===========================================================================================================
  getEvalForm: async function (store, role, period, typeform) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalDocente/GetGenericForm/' + role + '/' + period + '/' + typeform)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  //= ===========================================================================================================
  // función para obtener los datos de una persona por numero de documento
  //= ===========================================================================================================
  ListPersonByDocument: async function (store, numDocument) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Person/ListPersonByDocument/' + numDocument)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  //= ===========================================================================================================
  // función para consultar los avales del proceso de grados por id banner
  //= ===========================================================================================================
  GetHoldStatusByIdBanner: async function (store, idBanner) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Hold/HoldStatusByIdBanner/' + idBanner)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  //= ===========================================================================================================
  // función para consultar formularios diligenciados
  //= ===========================================================================================================
  GetFormSuccess: async function (store, id, period, nrc) {
    try {
      debugger
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalDocente/GetFormSuccess/24/' + id + '/' + period + '/' + nrc)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  //= ===========================================================================================================
  // función para consultar el id persona por id banner
  //= ===========================================================================================================
  GetIdPersonByIdBanner: async function (store, idbanner) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalDocente/GetIdPersonByIdBanner/' + idbanner)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  //= ===========================================================================================================
  // función para consultar las preguntas de un formulario eval docente
  //= ===========================================================================================================
  getEvalFormQuestion: async function (store, idform) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalDocente/GetGenericFormQuestion/11/' + idform)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  //= ===========================================================================================================
  // función para insertar las respuestas al formulario
  //= ===========================================================================================================
  insertFormAnswer: async function (store, iggenericform, idperson, request, personevaluated, idperiod, nrc) {
    try {
      var InfData = {
        id_Generic_Form: iggenericform,
        id_Person: idperson,
        request: request,
        person_Evaluated: personevaluated,
        id_Period: idperiod,
        nrc: nrc,
      }
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'EvalDocente/InsertFormAnswer/', InfData, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  //= ===========================================================================================================
  // función para consultar los periodos evaluados por el docente
  //= ===========================================================================================================
  getPeriodSuccess: async function (store, idperson) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalDocente/GetPeriodSuccess/' + idperson)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  //= ===========================================================================================================
  // función para consultar el tipo de formulario
  //= ===========================================================================================================
  getFormType: async function (store, formname) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalDocente/GetFormType/' + formname)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  //= ===========================================================================================================
  // función para consultar las actividades docente
  //= ===========================================================================================================
  getTeacherActivities: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalDocente/GetActivities/1')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  //= ===========================================================================================================
  // función para insertar las horas del docente
  //= ===========================================================================================================
  insertHoursAnswer: async function (store, idperson, request, idperiod) {
    try {
      var InfData = {
        id_Person: idperson,
        teacher_Request: request,
        id_Period: idperiod,
      }
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'EvalDocente/InsertTeacherHour/', InfData, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  //= ===========================================================================================================
  // función para retornar los periodos de un docente
  //= ===========================================================================================================
  /* getTeacherPeriods: async function (store, idbanner) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalDocente/GetTeacherPeriodsBanner/' + idbanner)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  }, */

  getTeacherPeriod: async function (store, idbanner) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalDocente/GetTeacherPeriod/' + idbanner)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  getTeacherHour: async function (store, idbanner) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalDocente/GetTeacherHours2/' + idbanner)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  //= ===========================================================================================================
  // función para retornar los programas de director a evaluar
  //= ===========================================================================================================
  getDirectorPrograms: async function (store, idbanner, idrole) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalDocente/GetDirectorPrograms/' + idbanner + '/' + idrole)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }

    return this.availabilityMessage
  },

  //= ===========================================================================================================
  // función para consultar formularios diligenciados
  //= ===========================================================================================================
  GetFormSuccessDDV: async function (store, id, idpersonev, period, nrc) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalDocente/GetFormSuccessDDV/' + id + '/' + idpersonev + '/' + period + '/' + nrc)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  GetCalificacion: async function (store, idBanner, period, signature) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalDocente/GetCalifDirector/' + idBanner + '/' + period + '/' + signature)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  //= ===========================================================================================================
  // función para retornar toda la data de programas, facultad y periodos
  //= ===========================================================================================================
  getAllDataYear: async function (store, year, degree) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalDocente/GetBannerAllDataYear/' + year + '/' + degree)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  //= ===========================================================================================================
  // función para retornar el promedio de calificación estudiante/docente por periodo especifico
  //= ===========================================================================================================
  getTeacherAverage: async function (store, idbanner, period) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalDocente/GetTeacherAverage/' + idbanner + '/' + period)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  GetTeacherByCodigo: async function (store, idbanner, year) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalDocente/GetTeacherByCodigo/' + idbanner + '/' + year)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  GetTeacherPeriodsCodigoPrograma: async function (store, idBanner, year) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalDocente/GetTeacherPeriodsCodigoPrograma/' + idBanner + '/' + year)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  getRegistrationPayOrder: async function (endpoint, idDocument, desPeriod) {
    try {
      this.availabilityMessage = await axios.get(endpoint + 'Inscription/GetRegistrationPayOrder/' + idDocument + '/' + desPeriod)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  postPayOrderInscripcionOMA: async function (store, datainf) {
    try {
      var InfData = {
        periodo: this.dataObjFind(store.state.PeriodoList, datainf.IdConvoca).split(' ')[0],
        tipo_identificacion: datainf.IdDocType,
        identificacion: datainf.IdDocument,
        primer_nombre: datainf.IdNombreP.trim(),
        segundo_Nombre: datainf.IdNombreS.trim(),
        primer_apellido: datainf.IdApellidosP.trim(),
        segundo_apellido: datainf.IdApellidosS.trim(),
        direccion: datainf.IdAddress,
        telefono: datainf.IdHomePhone,
        genero: this.dataObjFind(store.state.GenderList, datainf.IdGender),
        estado_civil: this.dataObjFind(store.state.MaritalStatusList, datainf.IdCivilState),
        email: datainf.IdMail,
        fecha_nacimiento: datainf.IdDaySelectBirth + '/' + datainf.IdMonthSelectBirth + '/' + datainf.IdYearSelectBirth,
        celular: datainf.IdCelPhone,
        pais: datainf.IdNacionality,
        departamento: datainf.IdStateRes,
        poblacion: datainf.IdCityRes,
        cod_programa: datainf.IdInteProgram,
        origen: 'Intranet',
      }
      debugger
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSUtilitary + 'Inscription/CreateOrderOMA/', InfData, config)
      debugger
    } catch (error) {
      debugger
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  dataObjAllFind: function (infoDaT, FinDaT) {
    if (infoDaT != '' || FinDaT != '') {
      var valuefin = infoDaT.find(element => element.id == FinDaT)
      if (valuefin != undefined) {
        return valuefin
      }
    }
    return FinDaT
  },
  sendFormInscription: async function (store, datainf, dataAddres) {
    try {
      // validar 2 nivel Etnia Ethnicity
      // idEthnicity
      debugger
      if (datainf.IdEtniaRef != 0) {
        datainf.IdEtnia = datainf.IdEtniaRef
      }

      if (datainf.IdYearTitu === undefined) {
        datainf.IdYearTitu = ''
      }

      if (datainf.CodDepartmentSchool === undefined) {
        datainf.CodDepartmentSchool = ''
      }

      if (datainf.CodCitySchool === undefined) {
        datainf.CodCitySchool = ''
      }

      if (datainf.IdCityCol === undefined) {
        datainf.IdCityCol = ''
      }

      if (datainf.IdJornadaEsc === undefined) {
        datainf.IdJornadaEsc = ''
      }

      if (datainf.IdNumRegICFES === undefined) {
        datainf.IdNumRegICFES = ''
      }

      if (datainf.IdNumRegYearICFES === undefined) {
        datainf.IdNumRegYearICFES = ''
      }

      if (datainf.IdDocTypeICFES === undefined) {
        datainf.IdDocTypeICFES = ''
      }

      if (datainf.IdNumICFE === undefined) {
        datainf.IdNumICFE = ''
      }

      var InfData = {
        idOperator: '' + datainf.IdOperator,
        idLevel: datainf.IdLevelForm,
        idDocumentType: datainf.IdDocType,
        nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
        numDocument: datainf.IdDocument,
        // doc_ExpeditionDate: new Date(datainf.IdDaySelect + "/" + datainf.IdMonthSelect + "/" + datainf.IdYearSelect).toLocaleDateString(),
        doc_ExpeditionDate: datainf.IdDaySelect + '/' + datainf.IdMonthSelect + '/' + datainf.IdYearSelect,

        codExpeditionDepartment: datainf.IdState,
        nameExpeditionDepartment: this.dataObjFind(store.state.StateList, datainf.IdState),
        codExpeditionCity: datainf.IdCity,
        nameExpeditionCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
        namPerson: datainf.IdNombreP.trim() + ' ' + datainf.IdNombreS.trim(),
        lastNamePerson: datainf.IdApellidosP.trim() + ' ' + datainf.IdApellidosS.trim(),
        resAddress: datainf.IdAddress,

        resAddressZone: dataAddres.IdAddressList,
        resAddressStreet: dataAddres.IdAddressStreet,
        resAddressNumber: dataAddres.IdAddressNum,
        resAddressReference: dataAddres.IdAddressRef,
        resAddressAditional: dataAddres.IdAddressExtra,

        resNeighborhood: 'BRR ' + datainf.IdNeighbor,
        codResidenceDepartment: datainf.IdStateRes,
        nameResidenceDepartment: this.dataObjFind(store.state.StateList, datainf.IdStateRes),
        codResidenceCity: datainf.IdCityRes,
        nameResidenceCity: this.dataObjFind(store.state.CityListRes, datainf.IdCityRes),
        codNationality: datainf.IdNacionality,
        nameNationality: this.dataObjFind(store.state.CountriesList, datainf.IdNacionality),
        codBirthDepartment: datainf.IdStateBirth,
        nameBirthDepartment: this.dataObjFind(store.state.StateList, datainf.IdStateBirth),
        codBirthCity: datainf.IdCityBirth,
        nameBirthCity: this.dataObjFind(store.state.CityListBirth, datainf.IdCityBirth),
        // birthDate: new Date(datainf.IdDaySelectBirth + "/" + datainf.IdMonthSelectBirth + "/" + datainf.IdYearSelectBirth).toLocaleDateString(),

        birthDate: datainf.IdDaySelectBirth + '/' + datainf.IdMonthSelectBirth + '/' + datainf.IdYearSelectBirth,
        idGender: datainf.IdGender,
        nameGender: this.dataObjFind(store.state.GenderList, datainf.IdGender),
        // validar 2 nivel
        idEthnicity: datainf.IdEtnia,
        nameEthnicity: this.dataObjFind(store.state.EthnicityList, datainf.IdEtnia),
        idLeyveteranos: datainf.IdLeyVete,
        idDesability: datainf.IdDiscapa,
        nameDesability: this.dataObjFind(store.state.DesabilityList, datainf.IdDiscapa),
        idMaritalStatus: datainf.IdCivilState,
        nameMaritalStatus: this.dataObjFind(store.state.MaritalStatusList, datainf.IdCivilState),
        idEPS: '' + datainf.IdEPS,
        idEPSQA: '' + datainf.IdEPSQA,
        IdEstrato: datainf.IdEstrato,
        termsConditions: datainf.IdTermiCondi,
        idContactTypePhone: 1,
        desContactInformationPhone: datainf.IdHomePhone,
        idContactTypeMobile: 2,
        desContactInformationMobile: datainf.IdCelPhone,
        idContactTypeEmail: 3,
        desContactInformationEmail: datainf.IdMail,

        idContactTypeNameEmergency: 5,
        desContactInformationNameEmergency: datainf.IdContactName,
        idContactTypePhoneEmergency: 4,
        desContactInformationPhoneEmergency: datainf.IdContactPhone,

        desContactInformationContactCity: datainf.IdContactCity,
        desContactInformationContactAdres: datainf.IdContactAdres,
        DesContactInformationWork: datainf.IdWork,
        DesContactInformationPersons: datainf.IdPersons,
        DesContactInformationMaterial: datainf.IdMaterial,

        idKinship: 1,
        famName: datainf.IdNombreP,
        famLastName: datainf.IdApellidosP,
        numPhone: datainf.IdHomePhone,
        numCellPhone: datainf.IdCelPhone,
        famAddress: datainf.IdAddress,
        fam_Email: datainf.IdMail,
        valIncomeMonthly: 1,
        valExpenseMonthly: 1,
        valOtherIncome: 1,
        desOtherIncome: '',
        comName: datainf.IdNombreP,
        com_Address: datainf.IdAddress,
        comPhoneNumber: datainf.IdHomePhone,
        comEmail: datainf.IdMail,
        valSalary: 1,
        idSchoolType: (datainf.IdTypeColegio === '') ? 0 : datainf.IdTypeColegio,
        nameSchoolType: this.dataObjFind(store.state.TipocColegioList, datainf.IdTypeColegio),
        namSchool: datainf.IdColegio,
        TitlePregrado: datainf.TituloPregrado,
        codDepartmentSchool: datainf.IdStateCol,
        nameDepartmentSchool: this.dataObjFind(store.state.StateList, datainf.IdStateCol),
        codCitySchool: datainf.IdCityCol,
        nameCitySchool: this.dataObjFind(store.state.CityListCol, datainf.IdCityCol),
        idWorkdaySchool: (datainf.IdJornadaEsc === '') ? 0 : datainf.IdJornadaEsc,
        nameWorkdaySchool: this.dataObjFind(store.state.JornadaList, datainf.IdJornadaEsc),
        DateEndSchool: datainf.IdDaySelectCol + '/' + datainf.IdMonthSelectCol + '/' + datainf.IdYearSelectCol,
        icfesRegistrationNumber: datainf.IdNumRegICFES,
        icfesYear: datainf.IdNumRegYearICFES,
        icfesIdentificationType: '' + datainf.IdDocTypeICFES,
        icfesIdentificationNumber: datainf.IdNumICFES,

        typeIncome: datainf.IdTypeIncome,
        idProgram: datainf.IdInteProgram,
        nameProgram: this.dataObjFind(store.state.ProgramList, datainf.IdInteProgram),
        idModality: datainf.IdModalidad,
        nameModality: this.dataObjFind(store.state.ModalityList, datainf.IdModalidad),
        idWorkday: datainf.IdJornada,
        nameWorkday: this.dataObjFind(store.state.JornadaList, datainf.IdJornada),
        idPeriod: datainf.IdConvoca,
        namePeriod: this.dataObjFind(store.state.PeriodoList, datainf.IdConvoca).split(' ')[0],
        deepening: datainf.IdDeepening,
        IdFaculty: '',
        reqHomologation: datainf.IdHomolo,
        idHomLevelStudy: datainf.IdNivelEstu,
        nameHomLevelStudy: this.dataObjFind(store.state.DegreeList, datainf.IdNivelEstu),
        homEducationInstitution: datainf.IdInstiEdu,
        homObtainedTitle: datainf.IdTitulo,
        homGraduationYear: '' + datainf.IdYearTitu,
        idCreateBy: 1,
        idUpdatedBy: datainf.idUpdatedBy,
        checkMatricula: datainf.IdComproMatricula,
        IdPlan: '' + datainf.IdPlan,
      }
      debugger
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'Inscription/AddDealsPersonByZohoIntranet/', InfData, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  sendFormInscriptionTemp: async function (store, datainf) {
    try {
      debugger
      var InfData = {
        accountName: '' + datainf.IdOperator,
        idDocumentType: datainf.IdDocType,
        nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
        numDocument: datainf.IdDocument,
        // doc_ExpeditionDate: new Date(datainf.IdDateExpDoc).toLocaleDateString(),
        doc_ExpeditionDate: datainf.IdDaySelect + '/' + datainf.IdMonthSelect + '/' + datainf.IdYearSelect,
        nameExpeditionDepartment: this.dataObjFind(store.state.StateList, datainf.IdState),
        nameExpeditionCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
        namPerson: datainf.IdNombreP + ' ' + datainf.IdNombreS,
        lastNamePerson: datainf.IdApellidosP + ' ' + datainf.IdApellidosS,
        desContactInformationPhone: datainf.IdHomePhone,
        desContactInformationMobile: datainf.IdCelPhone,
        desContactInformationEmail: datainf.IdMail,
        utmSource: '',
        utmCampaign: datainf.Campaign,
        utmMedium: '',
        utmContent: '',
      }
      debugger
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSUtilitary + 'Inscription/CreateSignUpPersonByZoho/', InfData, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  getCountriesList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'Countries/GetAllCountry/', config).then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.CountriesList.push({ id: Response.data[i].codeCountry, value: Response.data[i].nameCountry })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getGenderList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'Gender/GetAllGender/', config).then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.GenderList.push({ id: Response.data[i].idGender, value: Response.data[i].namGender })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getEthnicityList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'Ethnicity/GetAllEthnicity/', config).then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.EthnicityList.push({ id: Response.data[i].idEthnicity, value: Response.data[i].namEthnicity })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getDesabilityList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'Desability/GetAllDesability/', config).then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.DesabilityList.push({ id: Response.data[i].idDesability, value: Response.data[i].namDesability })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getMaritalStatusList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'MaritalStatus/GetAllMaritalStatus/', config).then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.MaritalStatusList.push({ id: Response.data[i].idMaritalStatus, value: Response.data[i].namMaritalStatus })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getEPSList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'Eps/GetEPSList/', config).then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.EPSList.push({ id: Response.data[i].Id_Eps, value: Response.data[i].Nam_Eps })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getEPSQAList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'Eps/GetEPSQAList/', config).then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.EPSQAList.push({ id: Response.data[i].Id_EpsQuality, value: Response.data[i].Nam_EpsQuality })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getProgramsListByOperator: function (endpoint, store, IdOperator, IdLevelForm) {
    axios.get(endpoint + 'Program/ListByOperator/' + IdOperator + '/' + IdLevelForm, config).then(
      Response => {
        store.length = 0
        for (var i = 0; i < Response.data.length; i++) {
          store.push({ id: Response.data[i].id, value: Response.data[i].nameProgram, requirePayment: Response.data[i].requirePayment })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getModalityListByProgram: function (endpoint, store, IdProgram, IdOperator) {
    axios.get(endpoint + 'Modality/ListByprogramByOperator/' + IdProgram + '/' + IdOperator, config).then(
      Response => {
        store.length = 0
        for (var i = 0; i < Response.data.length; i++) {
          store.push({ id: Response.data[i].id, value: Response.data[i].nameModality })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getWorkdayListByModality: function (endpoint, store, IdModality, IdProgram, IdOperator) {
    axios.get(endpoint + 'Workday/ListByModalityByProgramByOperator/' + IdModality + '/' + IdProgram + '/' + IdOperator, config).then(
      Response => {
        store.length = 0
        for (var i = 0; i < Response.data.length; i++) {
          store.push({ id: Response.data[i].id, value: Response.data[i].namWorkday })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getPeriodListByWorkDay: async function (endpoint, IdWorkDay, IdModality, IdProgram, IdTypeIncome) {
    try {
      if (IdTypeIncome == 'N') {
        this.availabilityMessage = await axios.get(endpoint + 'Period/LisPeriod/' + IdWorkDay + '/' + IdModality + '/' + IdProgram + '/' + 'Primer Ingreso', config)
      } else {
        this.availabilityMessage = await axios.get(endpoint + 'Period/LisPeriod/' + IdWorkDay + '/' + IdModality + '/' + IdProgram + '/' + 'Homologante', config)
      }
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }

    return this.availabilityMessage
  },
  getPlanListByWorkDay: async function (endpoint, IdWorkDay, IdModality, IdProgram, IdTypeIncome) {
    try {
      if (IdTypeIncome == 'N') {
        this.availabilityMessage = await axios.get(endpoint + 'Period/LisPlan/' + IdWorkDay + '/' + IdModality + '/' + IdProgram + '/' + 'Primer Ingreso', config)
      } else {
        this.availabilityMessage = await axios.get(endpoint + 'Period/LisPlan/' + IdWorkDay + '/' + IdModality + '/' + IdProgram + '/' + 'Homologante', config)
      }
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }

    return this.availabilityMessage
  },
  getSchoolTypeList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'SchoolType/GetAllSchoolType/', config).then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.TipocColegioList.push({ id: Response.data[i].idSchoolType, value: Response.data[i].namSchoolType })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getWorkdaySchoolList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'Workday/GetListWorkday/', config).then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.JornadaList.push({ id: Response.data[i].id, value: Response.data[i].namWorkday })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  findContactByZoho: async function (store, datainf, valida) {
    try {
      // {"identificationNumber":"8979787900","mobile":"3009765676","phone":"7868678","email":"lauralugo778@hotmail.com","valida":"identificationNumber"}
      // https://localhost:44327/v1/Inscription/GetFind_ContactByZoho/8979787900/3009765676/878978978/lauralugo778%40hotmail.com/identificationNumber

      if (datainf.IdDocument == null || datainf.IdDocument == '') {
        datainf.IdDocument = '0'
      }
      if (datainf.IdCelPhone == null || datainf.IdCelPhone == '') {
        datainf.IdCelPhone = '0'
      }
      if (datainf.IdMail == null || datainf.IdMail == '') {
        datainf.IdMail = '0'
      }

      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Inscription/GetFind_ContactByZoho/' + datainf.IdDocument + '/' + datainf.IdCelPhone + '/3009765/' + datainf.IdMail + '/' + valida)

      if (valida == 'identificationNumber' && this.availabilityMessage.data == 'True') {
        alert('El documento de Identidad ingresado ya existe en nuestra base de datos, valide si el aspirante ya tiene una matricula activa en uno de nuestros programas, de no ser así pulse en siguiente.')
      }

      if (valida == 'mobile' && this.availabilityMessage.data == 'True') {
        alert('El número de teléfono ingresado ya existe en nuestra base de datos, valide si el aspirante ya tiene una matricula activa en uno de nuestros programas, de no ser así pulse en siguiente.')
      }

      if (valida == 'email' && this.availabilityMessage.data == 'True') {
        alert('El correo ingresado ya existe en nuestra base de datos, valide si el aspirante ya tiene una matricula activa en uno de nuestros programas, de no ser así pulse en siguiente.')
      }
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getWorkdayList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'Workday/GetListWorkday/', config).then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.WorkdayList.push({ id: Response.data[i].namWorkday, value: Response.data[i].namWorkday })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  formatBytes (bytes, decimals) {
    if (bytes === 0) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
  },
  getUserInscription: async function (store, datauser) {
    debugger
    try {
      var InfData = {
        idDocumentType: datauser.IdDocType,
        numDocument: datauser.IdDocument,
        desContactInformationMobile: datauser.IdCelPhone,
        desContactInformationEmail: datauser.IdMail,
      }
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSUtilitary + 'Inscription/GetSignUpPerson/', InfData, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getDegreeDocumentList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'Degree/GetAllDegreeDocuments/', config).then(
      Response => {
        store.state.DegreeDocumentList = Response.data
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  sendUpdloadFileWithName: async function (store, file, module, iduser) {
    try {
      debugger
      var availabilityMessageFile = new Array()
      for (var i = 0; i < file.length; i++) {
        debugger
        let formData = new FormData()
        formData.append('file', file[i].filedata)
        let availabilityMSF = await axios.post(store.state.ApiIbero.WSUtilitary + 'Utilities/UploadFileWithName?Nam_Module=' + module + '&Id_FilePerson=data' + i, formData, configFile)
        availabilityMessageFile.push({ idDocument: file[i].idFileModule, idUserSign: file[i].idDetailUser, wsDocument: availabilityMSF })
      }
      this.availabilityMessage = availabilityMessageFile
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  sendFilesByPerson: async function (store, objData) {
    try {
      var InfData = {
        listDoc: objData,
      }
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'Inscription/AddDocumentPerson/', InfData, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  sendFilesByPersonZoho: async function (store, objData, idFileRef) {
    try {
      var InfData = {
        idSignUpPersonDetail: idFileRef,
        dataZoho: objData,
      }
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'Inscription/AddDocumentPersonByZoho/', InfData, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  deleteFilesByPerson: async function (store, objData, uriDetail) {
    try {
      var InfData = {
        listDoc: objData,
        detailURI: uriDetail,
      }
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSUtilitary + 'Inscription/DeleteDocumentPerson/', InfData, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  // ------------------------------------------------------------------------------
  /* Modulo Rreproceso Creditos Negozia */
  // ------------------------------------------------------------------------------
  getCreditFinanciera: async function (store, typOrden, Orden, Token) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Financiera/ReloadOrderNegozia/' + typOrden + '/' + Orden + '/' + Token)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    debugger
    return this.availabilityMessage
  },

  // #endregion

  // #region Medulo Generación insignias digitales

  getStudentsList: async function (store, token) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Badge/GetListStudents/' + process.env.VUE_APP_TOKEN + '/' + token)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },

  sendBadges: async function (store, dataInfo, token) {
    try {
      var today = new Date()
      var formattedDate = `${today.getDate().toString().padStart(2, '0')}/${
        (today.getMonth() + 1).toString().padStart(2, '0')}/${today.getFullYear()}`
      debugger
      var participant = {
        participants: [
          {
            automatic: true,
            profile: 'p',
            branchId: '',
            groupId: dataInfo.plantilla,
            templateId: 'b4fecc8b-56f9-4fc7-a1ec-61c69d2a450b',
            notifications: {
              sms: 1,
              email: 1,
              whatsapp: 0,
            },
            firstname: dataInfo.nombres,
            lastname: dataInfo.apellidos,
            idtype: dataInfo.tipoDocumento,
            idnum: dataInfo.numeroDocumento,
            email: dataInfo.correo,
            // email: 'ivan.rincon@ibero.edu.co',
            phone: dataInfo.telefono,
            // phone: '+573193154009',
            dynamicData: {
              cargodeca: dataInfo.cargo,
              logrocompe: dataInfo.competencia,
              creditruta: dataInfo.creditos,
              horacertif: dataInfo.horas,
              fechaemite: formattedDate,
              nomdeca: dataInfo.decano,
            },
          },
        ],
      }

      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSUtilitary + 'Badge/GenerateBadge/' + process.env.VUE_APP_TOKEN + '/' + token, participant, config)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    debugger
    return this.availabilityMessage
  },
  // #endregion
  // #region EvalDocente Upload
  getImmediateBossesList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'EvalDocenteAdministrador/GetImmediateBosses').then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.ImmediateBossesList.push({ id: Response.data[i].idBanner, value: Response.data[i].nombreJefe })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getTeachersList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'EvalDocenteAdministrador/GetTeachers').then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.TeachersList.push({ id: Response.data[i].idBanner, value: Response.data[i].nombreProfesor })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  getImmediateBosses: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalDocente/GetListImmediateBosses/')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  getProgramsCodeList: function (store) {
    axios.get(store.state.ApiIbero.WSParametric + 'Program/GetAllProgramWithCode').then(
      Response => {
        for (var i = 0; i < Response.data.length; i++) {
          store.state.ProgramCodeList.push({ id: Response.data[i].codProgram, value: Response.data[i].nameProgram })
        }
      }
    ).catch(e => function (e) {
      console.log(e)
    })
  },
  CreateImmediateBoss: async function (store, InfData) {
    try {
      debugger
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSUtilitary + 'EvalDocente/InsertImmediateBoss', InfData)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  UpdateImmediateBoss: async function (store, InfData) {
    try {
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'EvalDocente/UpdateImmediateBoss', InfData)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  DeleteImmediateBoss: async function (store, idBoss) {
    try {
      this.availabilityMessage = await axios.delete(store.state.ApiIbero.WSUtilitary + 'EvalDocente/DeleteImmediateBoss?Id_Educational_Hierarchy=' + idBoss)
      return this.availabilityMessage // Devuelve la respuesta de axios.post
    } catch (error) {
      this.availabilityMessage = false
      console.log('Error en la solicitud:', error)
      if (error.response) {
        console.log('Código de estado HTTP:', error.response.status)
        console.log('Respuesta del servidor:', error.response.data)
      }
      return null
    }
  },
  processMassiveBosses: async function (store, InfData) {
    var sresp
    try {
      sresp = await axios.put(store.state.ApiIbero.WSUtilitary + 'EvalDocente/MassiveImmediateBosses?Id_File=' + InfData.Id_File)
    } catch (error) {
      sresp = 'error'
      console.log(error)
    }
    return sresp
  },
  getTeachers: async function (store) {
    try {
      this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'EvalDocente/GetListTeachers/')
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    }
    return this.availabilityMessage
  },
  CreateTeachers: async function (store, InfData) {
    try {
      this.availabilityMessage = await axios.post(store.state.ApiIbero.WSUtilitary + 'EvalDocente/InsertTeachers', InfData)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  UpdateTeachers: async function (store, InfData) {
    try {
      this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'EvalDocente/UpdateTeachers', InfData)
    } catch (error) {
      this.availabilityMessage = false
      console.log(error)
    };
    return this.availabilityMessage
  },
  processMassiveTeachers: async function (store, InfData) {
    var sresp
    try {
      sresp = await axios.put(store.state.ApiIbero.WSUtilitary + 'EvalDocente/MassiveTeachers?Id_File=' + InfData.Id_File)
    } catch (error) {
      sresp = 'error'
      console.log(error)
    }
    return sresp
  },
})
